import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import WorkExperience from './pages/WorkExperience';
import Education from './pages/Education';
import RevisionNotes from './pages/RevisionNotes';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    const pathToTitle = {
      '/': 'Home - Ronaldo Butrus',
      '/portfolio': 'Portfolio - Ronaldo Butrus',
      '/work-experience': 'Work Experience - Ronaldo Butrus',
      '/education': 'Education - Ronaldo Butrus',
      '/revision-notes': 'Revision Notes - Ronaldo Butrus'
    };
    
    const title = pathToTitle[location.pathname] || 'Ronaldo Butrus';
    document.title = title;
  }, [location]);

  return (
    <div className="App d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/work-experience" element={<WorkExperience />} />
          <Route path="/education" element={<Education />} />
          <Route path="/revision-notes" element={<RevisionNotes />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
